import { useState, useEffect } from "react";
import { throttle } from "lodash";

// Breakpoints aligned with utils/styles.scss
const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  largeDesktop: 1200,
};

const screenSizes = ["mobile", "tablet", "desktop", "largeDesktop"] as const;
export type ScreenSize = (typeof screenSizes)[number];

export default function useScreenSize() {
  const [screenSize, setScreenSize] = useState<ScreenSize>(getScreenSize());

  useEffect(() => {
    const handleResize = throttle(() => {
      setScreenSize(getScreenSize());
    }, 50);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    screenSize,

    // Direct screen size checks
    mobile: screenSize === "mobile",
    tablet: screenSize === "tablet",
    desktop: screenSize === "desktop",
    largeDesktop: screenSize === "largeDesktop",

    below: (size: ScreenSize) =>
      screenSizes.indexOf(screenSize) < screenSizes.indexOf(size),
    upFrom: (size: ScreenSize) =>
      screenSizes.indexOf(screenSize) >= screenSizes.indexOf(size),
  };
}

const getScreenSize = (): ScreenSize => {
  const width = window.innerWidth;

  if (width < breakpoints.tablet) {
    return "mobile";
  }
  if (width < breakpoints.desktop) {
    return "tablet";
  }
  if (width < breakpoints.largeDesktop) {
    return "desktop";
  }
  return "largeDesktop";
};
